<template>
  <div class="fts-link">
    <input
      type="text"
      class="fts-form-control"
      :class="{'form-control--error': error}"
      :placeholder="placeholder"
      :autocomplete="autocomplete"
      v-model="mutableValue"
      @input="$emit('input')"
      @blur="$emit('blur')"
    >
  </div>
</template>

<script>
import commons from '../commons/commons';

export default {
  props: {
    value: [Object, String],
    placeholder: String,
    autocomplete: String,
    error: Boolean
  },
  model: {
    prop: "value",
    event: "updateValue"
  },
  computed: {
    mutableValue: {
      get() {
        if (this.value && commons.isObject(this.value)) {
          if (this.value.hasOwnProperty('url')) {
            return this.value.url;
          } else {
            return null;
          }
        }

        return this.value;
      },
      set(val) {
        this.$emit("updateValue", val); 
      }
    }
  }
}
</script>